import { render } from "./uni_slicedTable.vue?vue&type=template&id=7526cb81"
import script from "./uni_slicedTable.vue?vue&type=script&lang=js"
export * from "./uni_slicedTable.vue?vue&type=script&lang=js"

import "./uni_slicedTable.vue?vue&type=style&index=0&id=7526cb81&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__